// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  
  
  class EditPlace extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        data_uploaded: false,
        data_error: false,
        place_id: props.match.params.id,  
        place_details: {
            name:'',
            place_type: 0,
            priotity: 0,
            category:0,
            flat_size:0,
            address:'',
            location_id:'',
            venue_id: '',
            contact_name:'',
            contact_number: '',
            ass_sec_name:'',
            ass_sec_number:'',
            ass_sec_email:'',
            club_manager_name:'',
            club_manager_number:'',
            club_manager_email:'',
            notice_board_count:0,
            cost_per_week:0,
            is_badminton_court_available:'',
            badminton_court_count:0,
            is_football_court_available:'',
            football_court_count:0,
            other_activities:'',
            event_cost:0,
            competition_inside:'',
            distance:'',
            status: '',
            remarks:'',
            additional_details: {}
        }, 
        location_list: [],
        venue_list: [],
        priority_list:[],
        type_list:[],
        category_list:[],
        size_list:[],
        search:false,
        customer_search_list: [],
        dialog_open_cust:true,
        amount:0,
        dialog:false,
      };
      this.handleChange = this.handleChange.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
      this.handleLocationChange = this.handleLocationChange.bind(this)
    }
  
    componentDidMount() {
        this.getPlace();
        this.getDetails();
    }

    handlecustClose = () => {
      this.setState({dialog_open_cust:false});
    };

    handleOpen=()=>{
      this.setState({dialog_open_cust:true})
    }    

    getPlace(){
      const url = `${getLocationOrigin()}/place/get_place/?place_id=${this.state.place_id}`;
      const options = {...defaultOptions};
      options['method'] = 'get';
      options['headers'] = {'content-type': 'application/json'}
      // options['body'] = JSON.stringify({'place_id': this.state.place_id})

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
          if(data.success === true){
           this.setState({success:data.success,message:data.message,venue_list:data.buddy_venues,selected_venue:data.result.venue_id, place_details: data.result});
          }
          else{
            this.setState({success:data.success, message: data.message});
          }
           // alert("fix");
           console.log(data.message)
       }).catch(error => error);
    }

    getDetails(){
      const url = `${getLocationOrigin()}/get_venue_list/get_details_for_apartment_addition/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({location_list:data.result.locations,venue_list:data.result.locations[0].venues,type_list:data.result.types,
                          category_list:data.result.categories, priority_list:data.result.priorities,
                          size_list:data.result.flats},()=>{this.setData(data)});
           // alert("fix");
       }).catch(error => error);
    }



    postUpdateBooking(details,props) {
      console.log(details)
        const url = `${getLocationOrigin()}/place/edit_place/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                                          'place_id': this.state.place_id,
                                          'place_details':details
                                              });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(function(response){                     
              alert(response.message);
              window.location = document.referrer;
              props.history.goBack();
          })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }


    handleChange(event) {
        const name = event.target.name;
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        var new_value =  Object.assign({}, this.state.place_details);
        new_value[name] = value
        this.setState({place_details: new_value});
        // this.getAmount(this.state.equipment_details)
    }

    handleLocationChange(event) {
      const name = event.target.name;
      const value = event.target.value;
      const selected_loc = this.state.location_list.find(loc=> loc.location_id == value)
      var new_value =  Object.assign({}, this.state.place_details);
      new_value[name] = value
      new_value['venue_id'] = selected_loc.venues[0].venue_id
      this.setState({place_details: new_value, venue_list:selected_loc.venues})
    }

    handleSubmit(event) {
        console.log('handle')
        event.preventDefault();
        console.log('Submit');
        var details = this.state.place_details
        this.postUpdateBooking(this.state.place_details ,this.props)
    }

    setData(data) {
        var new_value =  Object.assign({}, this.state.place_details);
        new_value['name'] = data.result.name
        new_value['place_type'] = data.result.place_type
        new_value['priority'] = data.result.priority
        new_value['category'] = data.result.category
        new_value['flats_count'] = data.result.flats_count
        new_value['address'] = data.result.address
        new_value['distance'] = data.result.distance
        new_value['contact_name'] = data.result.contact_name
        new_value['contact_number'] = data.result.contact_number
        new_value['ass_sec_name'] = data.result.assc_sec_name
        new_value['ass_sec_number'] = data.result.assc_sec_no
        new_value['ass_sec_email'] = data.result.assc_sec_email
        new_value['club_manager_name'] = data.result.manager_name
        new_value['club_manager_number'] = data.result.manager_no
        new_value['club_manager_email'] = data.result.manager_email
        new_value['notice_board_count'] = data.result.notice_board_count
        new_value['cost_per_week'] = data.result.cost_per_week
        new_value['is_badminton_court_available'] = data.result.is_badminton_court_available
        new_value['badminton_court_count'] = data.result.badminton_court_count
        new_value['is_football_court_available'] = data.result.is_football_court_available
        new_value['football_court_count'] = data.result.football_court_count
        new_value['other_activities'] = data.result.other_activities
        new_value['event_cost'] = data.result.event_cost
        new_value['competition_inside'] = data.result.competition_inside
        new_value['status'] = data.result.status
        new_value['venue_id'] = data.result.venue
        new_value['location_id'] = data.result.location
        new_value['remarks'] = data.result.remarks
        this.setState({place_details: new_value});
    }


  
    render() {
        console.log('amount')
        console.log(this.state.place_details);
        console.log(this.state.venue_list)
        console.log(this.state.selected_venue)
        console.log(this.state.place_id)
        console.log(this.state.success)
        console.log(this.state.message)
        
      return(

        <div style={styles.container}> 
          <div className="row col-md-9 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12">
              <h3 style={{textAlign:'center'}}> Edit Place</h3>
            </div>

            <form  className="validated-form form-horizontal">

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Place Name
                </div>
                <input style={styles.input} className="required" name="name" value={this.state.place_details.name}
                onChange={this.handleChange} />
              </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Location
              </div>
             <select name="location_id" className="col-md-6" style={styles.item_body} value={this.state.place_details.location_id}
               onChange={this.handleLocationChange}>
                {
                   this.state.location_list.map((list,index)=>
                    <option key={list.location_id} value={list.location_id}>{list.location}</option>
                    )
                 }
             </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Nearest Venue
              </div>
             <select name="venue_id" className="col-md-6" style={styles.item_body} value={this.state.place_details.venue_id}
               onChange={this.handleChange}>
                {
                   this.state.venue_list.map((list,index)=>
                    <option key={list.venue_id} value={list.venue_id}>{list.venue}</option>
                    )
                 }
             </select>
            </div>

            <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Address
                </div>
                <textarea style={styles.textbox} className="required" name="address"
                onChange={this.handleChange} />
            </div>

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Type
                </div>
                <select name="place_type" className="col-md-6" style={styles.item_body} value={this.state.place_details.place_type}
                  onChange={this.handleChange}>
                  {
                    Object.keys(this.state.type_list).map((list,index)=>
                    <option key={index} value={index}>{this.state.type_list[index]}</option>
                    )
                  }
                </select>
              </div>

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Priority
                </div>
                <select name="priotity" className="col-md-6" style={styles.item_body} value={this.state.place_details.priotity}
                  onChange={this.handleChange}>
                  {
                    Object.keys(this.state.priority_list).map((list,index)=>
                    <option key={index} value={index}>{this.state.priority_list[index]}</option>
                    )
                  }
                </select>
              </div>

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Number of Flats
                </div>
                <select name="flat_size" className="col-md-6" style={styles.item_body} value={this.state.place_details.flat_size}
                  onChange={this.handleChange}>
                  {
                    Object.keys(this.state.size_list).map((list,index)=>
                    <option key={index} value={index}>{this.state.size_list[index]}</option>
                    )
                  }
                </select>
              </div>

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Category
                </div>
                <select name="category" className="col-md-6" style={styles.item_body} value={this.state.place_details.category}
                  onChange={this.handleChange}>
                  {
                    Object.keys(this.state.category_list).map((list,index)=>
                    <option key={index} value={index}>{this.state.category_list[index]}</option>
                    )
                  }
                </select>
              </div>

              <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Distance
              </div>
              <input style={styles.input} className="required" name="distance" placeholder='Eg. 1km or 500m' value={this.state.place_details.distance}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Contact Name
              </div>
              <input style={styles.input} className="required" name="contact_name" value={this.state.place_details.contact_name}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Contact Number
              </div>
              <input type="number" style={styles.input} className="required" name="contact_number" maxLength={10} value={this.state.place_details.contact_number}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Assoc. Secretary Name
              </div>
              <input style={styles.input} className="required" name="ass_sec_name" value={this.state.place_details.ass_sec_name}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Assoc. Secretary Number
              </div>
              <input type="number" style={styles.input} className="required" name="ass_sec_number" maxLength={10} value={this.state.place_details.ass_sec_number}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Assoc. Secretary Email
              </div>
              <input style={styles.input} className="required" name="ass_sec_email" value={this.state.place_details.assc_sec_email}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Club Manager Name
              </div>
              <input style={styles.input} className="required" name="club_manager_name" value={this.state.place_details.club_manager_name}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Club Manager Number
              </div>
              <input type="number" style={styles.input} className="required" name="club_manager_number" maxLength={10} value={this.state.place_details.club_manager_number}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Club Manager Email
              </div>
              <input style={styles.input} className="required" name="club_manager_email" value={this.state.place_details.club_manager_email}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Notice Board Count
              </div>
              <input style={styles.input} className="required" name="notice_board_count" value={this.state.place_details.notice_board_count}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Cost Per Week
              </div>
              <input style={styles.input} className="required" name="cost_per_week" value={this.state.place_details.cost_per_week}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items,{display:'flex'}} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Is badminton court available ?
              </div>
              <input type='checkbox' style={styles.input} className="required" name="is_badminton_court_available"
               checked={this.state.place_details.is_badminton_court_available} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Badminton Court Count
              </div>
              <input style={styles.input} className="required" name="badminton_court_count"
               value={this.state.place_details.badminton_court_count} onChange={this.handleChange}/>
            </div>

            <div style={styles.items,{display:'flex'}} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Is football court available ?
              </div>
              <input type='checkbox' style={styles.input} className="col-md-6" name="is_football_court_available"
               checked={this.state.place_details.is_football_court_available} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Football Court Count
              </div>
              <input style={styles.input} className="required" name="football_court_count"
               value={this.state.place_details.football_court_count} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Other Activities
              </div>
              <input style={styles.input} className="required" name="other_activities"  value={this.state.place_details.other_activities}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Event Cost
              </div>
              <input style={styles.input} className="required" name="event_cost"  value={this.state.place_details.event_cost}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items,{display:'flex'}} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Competition Inside ?
              </div>
              <input type='checkbox' style={styles.input} className="col-md-6" name="competition_inside" 
               checked={this.state.place_details.competition_inside} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Remarks
              </div>
              <textarea style={styles.textbox} name="status" rows="5"  value={this.state.place_details.remarks}
              onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Status
              </div>
              <textarea style={styles.textbox} name="status" rows="5"  value={this.state.place_details.status}
              onChange={this.handleChange}/>
            </div>
           
            <div style={{display:'flex', flexDirection:'row', padding:'1%', marginLeft:'10px'}}>
              <div style={styles.button_submit} className="col-md-12">
                <input className="btn btn-lg" type="submit" value="Edit Place" onClick={this.handleSubmit} style={{backgroundColor:'#302C35',
                  color:'#ffffff'}}/>
              </div>
              </div>     
          </form>
          </div>
        </div>
      );
    }
  }
  
  export default EditPlace;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editPlace/index.js